/**
 * Target Achievements Models
 * Exports all target-achievements related models
 */

export * from './point-structure';
export * from './achievements.interface';
